module.exports = __webpack_public_path__ + "img/banner-13.dfe2255d.jpg";